export default __webpack_public_path__ + "static/gemma-5bef11fee1312e0d8900b6434df83314.png";